import React from 'react'

function Error404() {
  return (
   <main>
    <div class="error-container p-0">
    <div class="container">
        <div>
            <div>
                <img alt="" class="img-fluid" src="../assets/images/background/error-404.png"/>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-lg-8 offset-lg-2 ">
                        <p class="text-center text-secondary f-w-500">Website owners should regularly check for and fix
                            broken links using tools like Google Search Console or other link-checking software.</p>
                    </div>
                </div>
            </div>
            <a class="btn btn-lg btn-light-primary b-r-22" href="/" role="button"><i class="iconoir-home-simple"></i>
                Back To
                Home</a>
        </div>
    </div>
</div>
   </main>
  )
}

export default Error404